import { useContext } from "react";
import ADimg from "../../assets/Frame 3465944.png";
import WalkinsCard from "./walkInsCard/WalkinsCard";
import { FunctionContext } from "../../context/FunctionProvider";




const AdImage = ({ src }) => {
  return <img className="Adimg" alt="" src={src}></img>;
};
function WalkIns({ walkinlist }) {
  const {
    generatePageNumber,
    page,
    query
  } = useContext(FunctionContext);
  return (
    <div className="search-list">
      
    {walkinlist?<><p className="wakinlist-header m-0">
        {" "}
        <strong className=""> page {page}-{generatePageNumber(walkinlist?.total, 5).totalPages}</strong> {Object.values(query).join("")?""+" WalkIns":"All WalkIns"}{" "}
      </p>
      {walkinlist.data.length!==0? (
        walkinlist?.data.map((element, index) =>
          index === 2 ? <>
          k
          <AdImage src={ADimg}></AdImage>
          <WalkinsCard key={index} detials={element}></WalkinsCard>
          </>   
          : ( 
            <WalkinsCard key={index} detials={element}></WalkinsCard>
          )
        )
      ) : 
      <h1>No Data Found </h1>
      }</>  :  <h1>Loading...</h1>}
    </div>
  );
}

export default WalkIns;
